import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MipdRoomService {
  mipdRoom: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mipd_room/list/?';
  private ListRecordByUnitId = webapi + 'mipd_room/listbyunitid/?';
  private DeListRecord = webapi + 'mipd_room/deactivated_list/?';
  private AddRecord = webapi + 'mipd_room/create';
  private EditRecord = webapi + 'mipd_room/update';
  private GetRecord = webapi + 'mipd_room/byid/';
  private DeleteRecord = webapi + 'mipd_room/delete/';
  private ReActiveRecord = webapi + 'mipd_room/reActive/';
  private GetWardByRoomId = webapi + 'mipd_room/bywardId/';

  constructor(private http: Http) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByUnitIDService(unitId, currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecordByUnitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  reActiveRecordService(id: any) {
    return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getByRoomIdService(id: any, unitId: any) {
    return this.http.get(this.GetWardByRoomId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getWardByRoomIdService(id: any) {
    return this.http.get(this.GetWardByRoomId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mipd-room/mipd-room.service.ts